import { render, staticRenderFns } from "./Coins.vue?vue&type=template&id=d99b3d7a&scoped=true&"
import script from "./Coins.vue?vue&type=script&lang=js&"
export * from "./Coins.vue?vue&type=script&lang=js&"
import style0 from "./Coins.vue?vue&type=style&index=0&id=d99b3d7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99b3d7a",
  null
  
)

export default component.exports